import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import Block from 'wfui-digital-core/es/Block';
import Guttered from 'wfui-digital-core/es/Guttered';
import PageContext from 'wfui-digital-core/es/PageContext';
import useDevice from 'wfui-digital-core/es/useDevice';
import useBrand from 'wfui-digital-core/es/useBrand';
import useWindowBounds from 'wfui-digital-core/es/useWindowBounds';
import scrollTop from '../../lib/scroll-top/scroll-top';
import useSettings from '../hooks/use-settings';
import ModuleError from '../module-error/ModuleError';
import ExceptionBoundary from '../exception-boundary/ExceptionBoundary';
import styles from './PageContent.less'; // Checks whether the newly focused element is behind the masthead.
// If it is, scroll the document to make the element visible. Note: we
// check to make sure the target node is a child of the page container to prevent
// the page scrolling when a modal opens and the focused element is above
// the masthead.

var scrollToElement = function scrollToElement(_ref) {
  var masthead = _ref.masthead,
      contentRef = _ref.contentRef;
  return function (_ref2) {
    var target = _ref2.target;

    if (masthead && target && contentRef && contentRef.current.contains(target)) {
      var mastheadBounds = masthead.getBoundingClientRect();
      var targetBounds = target.getBoundingClientRect();

      if (targetBounds.top < mastheadBounds.height) {
        var currentScroll = scrollTop();
        var scrollPosition = Math.max(currentScroll - (mastheadBounds.height - targetBounds.top) - 20, 0);
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
      }
    }
  };
};

var PageContent = function PageContent(_ref3) {
  var children = _ref3.children,
      dependenciesReady = _ref3.dependenciesReady,
      showModuleError = _ref3.showModuleError,
      moduleErrorMessage = _ref3.moduleErrorMessage;
  var containerRef = useRef();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      paddingTop = _useState2[0],
      setPaddingTop = _useState2[1];

  var device = useDevice();
  var brand = useBrand();

  var _useContext = useContext(PageContext),
      setContainerRef = _useContext.setContainerRef,
      getContainerRef = _useContext.getContainerRef;

  var _useSettings = useSettings(),
      useTPBBimUpdates = _useSettings.useTPBBimUpdates,
      useAltMasthead = _useSettings.useAltMasthead;

  var _useWindowBounds = useWindowBounds(),
      screenWidth = _useWindowBounds.width;

  var contentRef = useRef();
  var masthead = getContainerRef('masthead');
  var subMasthead = getContainerRef('submasthead');
  var navigationDisabled = useSelector(function (_ref4) {
    var core = _ref4.core;
    return core.navigation.navigationDisabled;
  });
  var globalSearchActive = useSelector(function (_ref5) {
    var core = _ref5.core;
    return core.globalSearch.open;
  });
  var keyboardOpen = useSelector(function (_ref6) {
    var digitalCore = _ref6.digitalCore;
    return digitalCore.device.keyboardOpen;
  });
  useEffect(function () {
    setContainerRef('content')(containerRef.current);
  }, [setContainerRef]);
  useEffect(function () {
    var mastheadHeight = masthead ? masthead.offsetHeight : 0;
    var subMastheadHeight = subMasthead ? subMasthead.offsetHeight : 0;

    if (keyboardOpen) {
      setPaddingTop(useTPBBimUpdates ? subMastheadHeight : 0);
    } else {
      setPaddingTop(mastheadHeight + subMastheadHeight);
    }
  }, [device, brand, masthead, navigationDisabled, globalSearchActive, screenWidth, useTPBBimUpdates, subMasthead, useAltMasthead, keyboardOpen]);
  return /*#__PURE__*/React.createElement(Block, {
    flex: true,
    layout: true,
    vertical: true,
    center: true,
    elementRef: contentRef,
    onFocus: scrollToElement({
      masthead: masthead,
      contentRef: contentRef
    }),
    className: styles.content,
    style: {
      paddingTop: paddingTop
    }
  }, /*#__PURE__*/React.createElement(Guttered, {
    layout: true,
    vertical: true,
    stretch: true,
    flex: true,
    elementRef: containerRef,
    "data-page-content": ""
  }, moduleErrorMessage ? /*#__PURE__*/React.createElement(ModuleError, {
    message: moduleErrorMessage
  }) : /*#__PURE__*/React.createElement(ExceptionBoundary, {
    onException: showModuleError
  }, dependenciesReady ? children : null)));
};

export default PageContent;